import React from 'react';
import { Section, SectionTitle } from '../Section';
import { Accordion } from '../Accordion';
import { modules } from '../../data/landing';
export function ModulesSection() {
  return <Section tone="wine" data-id="element-76" data-mp="2os2v29a36rhr">
      <SectionTitle data-id="element-77" data-mp="2osuphgry6j6g">Los 4 módulos</SectionTitle>
      <div className="mt-8" data-id="element-78" data-mp="2oq05fqcuj0dk">
        <Accordion idPrefix="module" items={modules.map(m => ({
        lead: String(m.number),
        title: m.title,
        body: m.text
      }))} data-id="element-79" data-mp="2trfsfnyl3gyl" />
      </div>
    </Section>;
}